/**
 * Better Auth React client for the admin (staff) UI (BL-787B).
 *
 * The staff sign-in page imports `authClient` from here to sign in via Google
 * OAuth (`signIn.social`), email + password (`signIn.email`), and email OTP
 * magic code (`emailOtp.sendVerificationOtp` / `signIn.emailOtp`).
 *
 * The client auto-detects the current page's origin and sends requests to
 * `/api/auth/*` on the same host — Better Auth's native catch-all route
 * (`/api/auth/[...all]`). Staff identity is global (no tenant scoping), so —
 * unlike bidder-web's client — there is no tenant plugin.
 *
 * Configured plugins must match the server's plugin list in `./better-auth.ts`
 * (emailOTP, customSession, bearer). `customSessionClient<StaffAuth>` pulls in
 * the server's `customSession` shape so consumers get typed access to the
 * folded `isSuperAdmin` / `tenantRoles` / `dbStaffUserId` fields.
 */
import { createAuthClient } from 'better-auth/react';
import { customSessionClient, emailOTPClient } from 'better-auth/client/plugins';

import type { StaffAuth } from '@auctogon/admin-services/services/auth/better-auth';

export const authClient = createAuthClient({
  plugins: [emailOTPClient(), customSessionClient<StaffAuth>()],
});

// Convenience re-exports — saves consumers from importing both `authClient`
// and the named methods separately.
export const { signIn, signOut, signUp, useSession, getSession, emailOtp } = authClient;
